import React from 'react'
import PropTypes from 'prop-types'
import {
  IconManager,
  coreIconPack,
  mediaControlsIconPack,
  ThemeProvider,
} from '@deseretbook/react-ui'
import { Logger } from '../../../dbcom'

import { Playlist } from './playlistTemplate'
import { Video } from './videoTemplate'

IconManager.register(coreIconPack, mediaControlsIconPack)

const logger = new Logger({ context: 'product/video/VideoTemplate' })

/**
 * Wrapper for VideoTemplate
 *
 * @returns {function} Component
 */
const TemplateContainer = ({
  product,
  user,
  libraryUrl,
  video,
  trailer,
  physicalVariants,
  playlist,
  videoVariant,
}) => {
  const optionsText = videoVariant.optionsText.toLocaleLowerCase()
  const Template = optionsText.includes('course') ? Playlist : Video

  return (
    <ThemeProvider>
      <Template
        product={product}
        user={user}
        libraryUrl={libraryUrl}
        playlist={playlist}
        video={video}
        trailer={trailer}
        physicalVariants={physicalVariants}
        videoVariant={videoVariant}
      />
    </ThemeProvider>
  )
}

TemplateContainer.propTypes = {
  user: PropTypes.shape({
    subscriptions: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  product: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    id: PropTypes.number,
    reviewsCount: PropTypes.number,
    avgRating: PropTypes.string,
    taxons: PropTypes.arrayOf(PropTypes.object),
  }),
  libraryUrl: PropTypes.string,
  video: PropTypes.PropTypes.shape({
    url: PropTypes.string,
    poster: PropTypes.string,
  }),
  trailer: PropTypes.shape({
    url: PropTypes.string,
    poster: PropTypes.string,
  }),
  physicalVariants: PropTypes.shape(PropTypes.any),
  playlist: PropTypes.arrayOf(PropTypes.any),
  videoVariant: PropTypes.shape(PropTypes.any),
}

export default TemplateContainer
